import { render, staticRenderFns } from "./polygonalFence.vue?vue&type=template&id=4599f5c2&scoped=true&"
import script from "./polygonalFence.vue?vue&type=script&lang=js&"
export * from "./polygonalFence.vue?vue&type=script&lang=js&"
import style0 from "./polygonalFence.vue?vue&type=style&index=0&id=4599f5c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4599f5c2",
  null
  
)

export default component.exports